import React, { useRef, useState, useEffect } from 'react';
import ReactModal from 'react-modal';
import { ReactComponent as CloseModalIcon } from '../../assets/svg/CloseModalIcon.svg';
import { ReactComponent as UploadDataIcon } from '../../assets/svg/UploadDataIcon.svg';
import { ReactComponent as ExitCross } from '../../assets/svg/ExitCross.svg';
import '../../styles/modals/StudentInfoModal.css';
import Loading from '../Loading';
import { useNavigate } from 'react-router-dom';
import { uploadExelFile, uploadFile } from '../../server/server';
import { notify } from '../../utils/util';

function ExportImportModal({ modalIsOpen, closeModal }: { modalIsOpen: any; closeModal: any }) {
	const [processing, setProcessing] = useState(false);
	const navigate = useNavigate();
	const [image, setImage] = useState<string | undefined>(undefined);
	const [selectedFile, setSelectedFile] = useState<any>(undefined);
	const [uploading, setUploading] = useState(false);
	const [errorText, setFileError] = useState('');

	const pressUploadPicture = () => {
		if (!!selectedFile) return;
		document.getElementById('photo_upload_modal')?.click();
	};

	const closeImage = () => {
		setImage(undefined);
		setSelectedFile(undefined);
		setUploading(false);
	};

	const onImageChange = (e: any) => {
		if (!e.target.files || e.target.files.length === 0) {
			setSelectedFile(undefined);
			return;
		}
		setFileError('');
		let file = e.target.files[0];
		if (file.size > 15728640) {
			alert('File is to big.');
			setSelectedFile(undefined);
			return;
		}
		setSelectedFile(file);
	};
	const resetInputValue = (e: any) => {
		e.target.value = null;
	};

	const cleanUpFunction = () => {
		setImage(undefined);
		setSelectedFile(undefined);
		setProcessing(false);
		setUploading(false);
	};

	const uploadFile = async () => {
		if (!selectedFile) return;
		setUploading(true);
		const resp = await uploadExelFile({ file: selectedFile });
		console.log('resp upload exel', resp);
		if (resp.status == 201) {
			notify('File is uploaded');
			setUploading(false);
			closeModal();
		} else {
			notify('File is not uploaded');
			setUploading(false);
			return;
		}
	};
	return (
		<ReactModal
			isOpen={modalIsOpen}
			onAfterOpen={() => {}}
			onAfterClose={() => cleanUpFunction()}
			onRequestClose={closeModal}
			style={{
				overlay: {
					zIndex: 7,
					background: '#00000045',
				},
				content: {
					padding: 0,
					paddingTop: 30,
					paddingBottom: 30,
					opacity: 1,
					width: 900,
					margin: 'auto',
					backgroundColor: 'transparent',
					maxHeight: '100vh',
					border: 'none',
					boxShadow: 'none',
					overflow: 'auto',
				},
			}}
			className={'scrollbar-display-none'}
		>
			<div className='student-info-modal  '>
				<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
					<div className='close-modal-icon transition' onClick={() => closeModal()}>
						<CloseModalIcon />
					</div>
				</div>
				<div className='flex-1 h-[290px] rounded-[10px] bg-[#ECEBF8] p-[20px] custom-shadow flex flex-col'>
					<div
						className={`flex-1 bg-[#FFFFFF] rounded-[10px] flex items-center border-2 justify-center transition-all duration-300 ease-in-out flex-col text-[#BEBECE] font-semibold relative
                                ${!!selectedFile ? 'border-[#BEBECE]' : 'pointer hover:border-[#BEBECE]  border-[#FFFFFF]'}
                            `}
						onClick={pressUploadPicture}
					>
						<UploadDataIcon />
						<div className='mt-[5px]'>{selectedFile ? selectedFile?.name : 'Attach file'}</div>
						{selectedFile && (
							<button
								className='flex h-[30px] w-[30px] rounded-full bg-[#BEBECE] items-center justify-center transition-all duration-300 ease-in-out absolute top-3 right-3 hover:bg-[#413F5E]'
								onClick={closeImage}
							>
								<ExitCross style={{ fill: 'white' }} />
							</button>
						)}
					</div>
					<div className='flex flex-row  mt-[20px] items-center'>
						<div className='flex-1  flex flex-row justify-between mr-[20px]'>
							<span></span>
							<p className='text-redError font-semibold text-[16px]'>{errorText}</p>
						</div>
						<button
							className={`h-[50px] w-[280px] flex items-center justify-center rounded-full bg-primaryViolet text-[#FDDF6D] font-bold text-[16px] transition-all ease-in-out duration-[230ms] 
                                    ${uploading ? '' : 'hover:bg-[#FDDF6D] hover:text-primaryViolet'}
                                `}
							onClick={uploadFile}
							disabled={uploading}
						>
							{uploading ? <Loading /> : 'Upload data'}
						</button>
					</div>
					<input
						title='Add File'
						style={{ display: 'none' }}
						accept='.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
						type='file'
						id='photo_upload_modal'
						onChange={onImageChange}
						onClick={resetInputValue}
					/>
				</div>
			</div>
		</ReactModal>
	);
}

export default ExportImportModal;
